import React, { memo, useMemo } from "react";
import { Blok } from "../../interfaces/Blok.interface";
import { StoryblokAsset } from "../../interfaces/StoryblokAsset.interface";
import StructuredData from "../StructuredData/StructuredData";

interface VideoStructuredDataBlokProps extends Blok {
  video_name: string;
  video_description: string;
  video_upload_date: string;
  video_duration: string;
  video_id: string;
  video_thumbnail: StoryblokAsset;
}

interface VideoStructuredDataProps {
  blok: VideoStructuredDataBlokProps;
}

const VideoStructuredData: React.FC<VideoStructuredDataProps> = ({ blok }) => {
  const {
    video_name,
    video_description,
    video_upload_date,
    video_duration,
    video_id,
    video_thumbnail
  } = blok;

  const videoStructuredData = useMemo(() => {
    let structuredData: Record<string, string> = {
      "@type": "VideoObject",
      name: video_name,
      description: video_description,
      uploadDate: video_upload_date,
      duration: video_duration,
      thumbnailUrl: video_thumbnail?.filename,
      embedUrl: `https://www.youtube.com/watch?v=${video_id}`
    };
    return structuredData;
  }, [blok]);

  return <StructuredData>{videoStructuredData}</StructuredData>;
};

export default memo(VideoStructuredData);
